import React from 'react';
import UIComponent from 'components/UiComponent';
import EvaluationFormContext from '../../../components/context';

export default class ProgressBar extends React.Component {
    constructor(props) {
        super(props);
    }

    _calculateBarWidth(questionIds,answers){
        if (Object.keys(answers).length) {
            let availableAnswers = 0;

            questionIds.forEach(id => {
                if (answers.hasOwnProperty(id) && answers[id] !== null && answers[id] !== undefined && answers[id] !== "") {
                    availableAnswers++;
                }
            });

            return availableAnswers / questionIds.length * 100 + "%";
        }
        return 0;
    }

    render() {
        return (
            <EvaluationFormContext.Consumer>
                {({ questionsIds }) => 
                    <UIComponent component="smart-form-consumer">
                        {({values}) => {
                            return <div className="evaluation-form-header__loader bg-green" style={{ width: this._calculateBarWidth(questionsIds,values)}}></div>
                        }}
                    </UIComponent>
                }
            </EvaluationFormContext.Consumer>
        )
    }
}
